var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DollarAmountInput',{attrs:{"name":"amount","validationName":"amount","errors":_vm.errors},model:{value:(_vm.fixedAmount),callback:function ($$v) {_vm.fixedAmount=$$v},expression:"fixedAmount"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }